// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".px-6{padding-left:5rem;padding-right:5rem}.button-action{text-align:center;margin-top:5rem}#email-input-group{padding:0px 23px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
